import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Full-viewport loading fallback. Used by:
 *   - <Suspense> for lazy-loaded route chunks (App.js)
 *   - <PrivateRoute> while AuthContext verifies the token
 */
const PageLoader = ({ label = 'Chargement…' }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      backgroundColor: 'background.default',
      color: 'text.secondary',
      zIndex: 1300,
    }}
  >
    <CircularProgress size={36} thickness={4} />
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {label}
    </Typography>
  </Box>
);

export default PageLoader;
